// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productPrimaryImageStyles } from "@conklin/Overrides/Components/ProductPrimaryImage";
import { color, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

productPrimaryImageStyles.centeringWrapper = {
    css: css`
        min-height: 300px;
        display: flex;
        align-items: center;
        justify-content: center;

        > img {
            height: auto;
            max-width: 100%;
            max-height: 500px;
        }
    `,
};
productPrimaryImageStyles.enlargeBtn = {
    css: css`
        position: absolute;
        right: 8px;
        bottom: 8px;
        z-index: 1;
        padding: 0;
        height: 16px;
        width: 16px;
    `,
};

productPrimaryImageStyles.zoomContainerStyles = {
    css: css`
        width: 100%;
        ${xScreen("gte", "lg")} {
            width: auto;
        }
        img ~ div:not(#zoomTargeted) {
            opacity: 0 !important;
        }

        #zoomTargeted {
            border: 1px solid ${color("common.border")};
            background-color: ${color("common.ui1")};
            z-index: 1280 !important;
            top: -45px;
            display: none;
            width: ${({ width }: any) => width}px;

            img {
                height: auto;
                width: auto;
            }
        }

        &:hover #zoomTargeted {
            display: block;
        }
    `,
};
productPrimaryImageStyles.img = {
    css: css`
        &&& {
            cursor: default;
        }
    `,
};
productPrimaryImageStyles.container = {
    css: css`
        position: relative;
    `,
};
